<template>
  <div class="systemlog">
    <div id="header_nav" class="header">
      <div class="logo border_box">
        <div class="logo_img"><img src=""></div>
        <div class="logo_txt wid300">天津市教育系统网络安全和舆情管控应急指挥平台</div>
      </div>
      <div class="userinfo_box">
        <div class="user_box" style="border: none;">
          <div class="el-dropdown" style="width: 150px;">
            <div class="user_img">
              <img src="/ssologin/static/images/user_icon.png">
              <span class="user_name">{{name}}</span>
            </div>
            <ul class="subset_nav">
              <div style="position:absolute;height: 30px;width: 100%;top:-30px;left:0;"></div>
              <li @click="gosetting('/Set/userinfo')">个人信息</li>
              <li @click="gosetting('/Set/groupManagement')" v-if="funList.length > 0">系统设置</li>
              <li @click="gosetting('/Set/systemLog')">日志审计</li>
              <li @click="gosetting('/exit')">退出</li>
              <div class="popper__arrow"></div>
            </ul>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
    <div id="goBack" class="goback" @click='$router.push("/loginIndex")'>返回</div>
    <div class="syscontent">
      <div class="search-box">
        <div>
          <span>账号名称</span>
          <el-input v-model="operLoginName" placeholder="请输入账号名" width='180px'></el-input>
        </div>
        <div>
          <span>系统名称</span>
          <el-input v-model="systemTitle" placeholder="请输入系统名"></el-input>
        </div>
        <div>
          <span>模块名称</span>
          <el-input v-model="moduleTitle" placeholder="请输入模块名"></el-input>
        </div>
        <div>
          <span>操作</span>
          <el-select v-model="businessType" placeholder="请选择操作">
            <el-option v-for="item in businessTypeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div>
          <span>时间</span>
          <div class="block">
            <el-date-picker v-model="startTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" :picker-options="start_date" placeholder="选择日期时间"></el-date-picker>
          </div>
          ～<el-date-picker v-model="endTime"  value-format="yyyy-MM-dd HH:mm:ss" type="datetime" :picker-options="end_date" placeholder="选择日期时间">
          </el-date-picker>
        </div>
        <el-button type="primary" style="height:40px" @click="searchList">搜索</el-button>
      </div>
      <div>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column type="index" width="50">
          </el-table-column>
          <el-table-column prop="operLoginName" label="账号名称" width="120">
          </el-table-column>
          <el-table-column prop="operName" label="用户名" width="120">
          </el-table-column>
          <el-table-column prop="systemTitle" label="系统">
          </el-table-column>
          <el-table-column prop="moduleTitle" label="模块">
          </el-table-column>
          <el-table-column prop="functionTitle" label="功能名称">
          </el-table-column>
          <el-table-column prop="businessType" label="操作" width='80px'>
          </el-table-column>
          <el-table-column prop="operTime" label="时间" width="175">
          </el-table-column>
        </el-table>
        <div class="block" style="margin-top:20px;text-align:center;" v-if='tableData.length > 0'>
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as loginAPI from "@/api/login.js";
export default ({
  data () {
    return {
      userid: '',
      funList: [],
      name: '',
      operLoginName: '',// 账号名
      systemTitle: '',// 系统名称
      moduleTitle: '',// 模块名称
      businessType: '',// 操作
      startTime: '',// 开始时间
      endTime: '',// 结束时间
      operLoginNameCheck: '',// 账号名
      systemTitleCheck: '',// 系统名称
      moduleTitleCheck: '',// 模块名称
      businessTypeCheck: '',// 操作
      startTimeCheck: '',// 开始时间
      endTimeCheck: '',// 结束时间
      currentPage: 1,
      pageSize: 10,
      total: 0,
      start_date: {// 开始时间范围限定
        disabledDate: (time) => {
          if (this.endTime) {
            var endTemp = new Date(this.endTime).getTime()
            return time.getTime() > endTemp
          }
          // return time.getTime() < Date.now() - 8.64e7
        }
      },
      end_date: {// 结束时间范围限定
        disabledDate: (time) => {
          if (this.startTime) {
            var startTemp = new Date(this.startTime).getTime()
            return time.getTime() < startTemp
          }
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      businessTypeList: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 1,
          label: '查询'
        }, {
          value: 2,
          label: '插入'
        }, {
          value: 3,
          label: '修改'
        }, {
          value: 4,
          label: '删除'
        }, {
          value: 5,
          label: '导出'
        }, {
          value: 6,
          label: '导入'
        }, {
          value: 7,
          label: '强退'
        }, {
          value: 9,
          label: '登录'
        }, {
          value: 0,
          label: '其他'
        }
      ],
      tableData: []
    }
  },
  created () {
    let userInfot = this._util.getStorage("ssoUserInfo");
    console.log(userInfot)
    this.name = userInfot.name;
    this.userid = userInfot.accountId;
    this.accountId = userInfot.accountId;
    this.getRoleFunList();
    this.getSystemList();
  },
  methods: {
    searchList () {
      this.currentPage = 1;
      this.operLoginNameCheck = this.operLoginName;// 账号名
      this.systemTitleCheck = this.systemTitle;// 系统名称
      this.moduleTitleCheck = this.moduleTitle;// 模块名称
      this.businessTypeCheck = this.businessType;// 操作
      this.startTimeCheck = this.startTime;// 开始时间
      this.endTimeCheck = this.endTime;// 结束时间
      this.getSystemList();
    },
    getSystemList () {
      let data = {
        operUserId: this.userid == 53180 ? '' : this.userid,// 用户ID
        operLoginName: this.operLoginNameCheck,// 账号名
        systemTitle: this.systemTitleCheck,// 系统名称
        moduleTitle: this.moduleTitleCheck,// 模块名称
        businessType: this.businessTypeCheck,// 操作
        cTime: this.startTimeCheck,// 开始时间
        eTime: this.endTimeCheck,// 结束时间
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      }
      loginAPI.getSystemList(data).then(res => {
        console.log(res)
        res.records.forEach((item,ind) => {
          let obj = this.businessTypeList[this.businessTypeList.findIndex(items => item.businessType == items.value)]
          res.records[ind].businessType = obj.label
        })
        
        this.tableData = res.records
        this.total = res.total
      })
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val
      this.searchList()
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val
      this.getSystemList()
    },
    gosetting (a) {
      if (a !== "/exit") {
        this.$router.push({
          path: a
        });
      } else {
        localStorage.clear();
        window.localStorage.clear();
        // window.location = window.expertConfig.newUrl+'exit';
        let data = {
          accountId: this.accountId
        };
        loginAPI.dologOut(data).then(res => {
          if (res.code == 0) {
            this.$router.push({
              path: "/"
            });
          }
        });
      }
    },
    getRoleFunList () {
      let data = {
        accountId: this.accountId
      };
      loginAPI.getRoleFunList(data).then(res => {
        if (res.code == 0) {
          this.funList = res.data.funList;
          this._util.setStorage(
            "ssoNav",
            res.data.funList[0].funSonList
          );
        }
      });
    },
  },
  mounted () {

  }
})
</script>
<style lang='less'>
html,
body {
  width: 100% !important;
  height: 100% !important;
}
#app {
  width: 100%;
  height: 100%;
}
// * {
//   box-sizing: border-box !important;
// }
.systemlog {
  min-width: 1120px;
  width: 100%;
  height: 100%;
  background: #f2f2f2;
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  min-height: 560px;
  overflow: auto;
  box-sizing: border-box;
  .syscontent {
    flex: 1;
    width: 94%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 3%;
    box-sizing: border-box;
    > div {
      width: 100%;
      background: #fff;
      padding: 10px 20px;
      border-radius: 10px;
      box-sizing: border-box;
    }
    .search-box {
      display: flex;
      flex-wrap: wrap;
      margin: 20px 0;
      > div {
        display: flex !important;
        align-items: center;
        width: auto;
        margin: 0 25px 15px 0;
        box-sizing: border-box;
        > span {
          display: inline-block;
          // width: 90px;
          margin-right: 10px;
        }
      }
    }
  }
}
.header {
  width: 100%;
  height: 64px;
  background-color: #0f2847;
  box-shadow: 0 2px 15px #e5e5e5;
  z-index: 888;
  min-width: 1100px;
  position: relative;
  .logo {
    width: 600px;
    float: left;
    height: 64px;
    padding: 8px 0;
    margin-left: 3%;
    overflow: hidden;
    font-size: 0;
    .wid300 {
      max-width: 100%;
      line-height: 48px;
    }
    .logo_txt {
      display: inline-block;
      font-size: 24px;
      color: #fff;
      vertical-align: middle;
      max-height: 48px;
      overflow: hidden;
    }
  }
  .userinfo_box {
    float: right;
    // margin-right: 5%;
  }
  .sys_setup {
    display: inline-block;
    width: 23px;
    height: 23px;
    background: url(../../images/setting.png) no-repeat;
    background-size: 20px 20px;
    vertical-align: top;
    margin: -1px 0 0 10px;
    cursor: pointer;
  }
}
.userinfo_box {
  float: right;
  // margin-right: 5%;
  // margin-top: 2%;
}
.userinfo_box .user_box {
  float: left;
  border-left: 1px solid #a5aabb;
  height: 18px;
  line-height: 18px;
  margin-top: 23px;
  margin-left: 12px;
  font-size: 0;
  position: relative;
}
.userinfo_box .user_box div.user_img {
  margin: 0 12px;
  cursor: pointer;
  display: flex;
}
.userinfo_box .user_box div.user_img img {
  display: inline-block;
  width: 16px;
  height: 16px;
  vertical-align: top;
  margin-top: 1px;
  border: 0px none;
}
.userinfo_box .user_box div.user_img span.user_name {
  font-size: 14px;
  color: #fff;
  white-space: nowrap;
}
.userinfo_box .user_box .subset_nav {
  position: absolute;
  top: 26px;
  left: -8px;
  padding: 10px 0;
  margin: 5px 0;
  background-color: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  width: 100px;
  display: none;
}
.userinfo_box .user_box .el-dropdown:hover .subset_nav {
  display: block;
}
.userinfo_box .user_box .subset_nav li {
  list-style: none;
  line-height: 36px;
  padding: 0 20px;
  margin: 0;
  font-size: 14px;
  color: #606266;
  cursor: pointer;
  outline: 0;
  width: auto;
  height: auto;
}
.userinfo_box .user_box .subset_nav li:hover {
  background-color: #ecf5ff;
}
.userinfo_box .user_box .subset_nav li:hover a {
  color: #409eff;
}
.userinfo_box .user_box .subset_nav li a {
  font-size: 14px;
  font-family: '\5B8B\4F53';
  color: #606266;
}
.userinfo_box .user_box .subset_nav li a:hover {
  color: #409eff;
}
.userinfo_box .user_box .subset_nav li a.hover {
  color: #409eff;
}
.userinfo_box .user_box .subset_nav .popper__arrow,
.userinfo_box .user_box .subset_nav .popper__arrow::after {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}
.userinfo_box .user_box .subset_nav .popper__arrow {
  border-width: 6px;
  filter: drop-shadow(0 2px 12px rgba(0, 0, 0, 0.03));
  left: 50%;
  top: -6px;
  border-top-width: 0;
  border-bottom-color: #ebeef5;
  margin-left: -6px;
}
.userinfo_box .user_box .subset_nav .popper__arrow::after {
  content: ' ';
  border-width: 6px;
  border-bottom-color: #fff;
  border-top-width: 0;
  margin-left: -6px;
  top: 1px;
}
.goback {
  background: #0f2847;
  cursor: pointer;
  margin-left: 40px;
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  margin-top: 10px;
  border-radius: 10px;
}
</style>
<style>
.el-table th {
  background: rgb(245, 247, 250);
}
.el-select .el-input,.search-box>div>.el-input {
  width: 195px !important;
}
.el-pagination__editor.el-input {
  width: 50px !important;
}
.el-pagination .el-select .el-input {
  width: 80px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Setting/SystemLog.vue